import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import { generateSelectorPath } from '../../../../common/dom/selector-path';
import { OBSERVED_WINDOW_EVENTS } from '../../constants';
import { AggregatedUserAction } from './aggregated-user-action';

var _aggregationEvent = /*#__PURE__*/new WeakMap();

var _aggregationKey = /*#__PURE__*/new WeakMap();

export var UserActionsAggregator = /*#__PURE__*/function () {
  function UserActionsAggregator() {
    _classCallCheck(this, UserActionsAggregator);

    _aggregationEvent.set(this, {
      writable: true,
      value: undefined
    });

    _aggregationKey.set(this, {
      writable: true,
      value: ''
    });
  }
  /** @type {AggregatedUserAction=} */


  _createClass(UserActionsAggregator, [{
    key: "aggregationEvent",
    get: function get() {
      // if this is accessed externally, we need to be done aggregating on it
      // to prevent potential mutability and duplication issues, so the state is cleared upon returning.
      // This value may need to be accessed during an unload harvest.
      var finishedEvent = _classPrivateFieldGet(this, _aggregationEvent);

      _classPrivateFieldSet(this, _aggregationKey, '');

      _classPrivateFieldSet(this, _aggregationEvent, undefined);

      return finishedEvent;
    }
    /**
     * Process the event and determine if a new aggregation set should be made or if it should increment the current aggregation
     * @param {Event} evt The event supplied by the addEventListener callback
     * @returns {AggregatedUserAction|undefined} The previous aggregation set if it has been completed by processing the current event
     */

  }, {
    key: "process",
    value: function process(evt) {
      if (!evt) return;
      var selectorPath = getSelectorPath(evt);
      var aggregationKey = getAggregationKey(evt, selectorPath);

      if (!!aggregationKey && aggregationKey === _classPrivateFieldGet(this, _aggregationKey)) {
        // an aggregation exists already, so lets just continue to increment
        _classPrivateFieldGet(this, _aggregationEvent).aggregate(evt);
      } else {
        // return the prev existing one (if there is one)
        var finishedEvent = _classPrivateFieldGet(this, _aggregationEvent); // then set as this new event aggregation


        _classPrivateFieldSet(this, _aggregationKey, aggregationKey);

        _classPrivateFieldSet(this, _aggregationEvent, new AggregatedUserAction(evt, selectorPath));

        return finishedEvent;
      }
    }
  }]);

  return UserActionsAggregator;
}();
/**
 * Generates a selector path for the event, starting with simple cases like window or document and getting more complex for dom-tree traversals as needed.
 * Will return a random selector path value if no other path can be determined, to force the aggregator to skip aggregation for this event.
 * @param {Event} evt
 * @returns {string}
 */

function getSelectorPath(evt) {
  var selectorPath;
  if (OBSERVED_WINDOW_EVENTS.includes(evt.type) || evt.target === window) selectorPath = 'window';else if (evt.target === document) selectorPath = 'document'; // if still no selectorPath, generate one from target tree that includes elem ids
  else selectorPath = generateSelectorPath(evt.target); // if STILL no selectorPath, it will return undefined which will skip aggregation for this event

  return selectorPath;
}
/**
 * Returns an aggregation key based on the event type and the selector path of the event's target.
 * Scrollend events are aggregated into one set, no matter what.
 * @param {Event} evt
 * @param {string} selectorPath
 * @returns {string}
 */


function getAggregationKey(evt, selectorPath) {
  var aggregationKey = evt.type;
  /** aggregate all scrollends into one set (if sequential), no matter what their target is
   * the aggregation group's selector path with be reflected as the first one observed
   * due to the way the aggregation logic works (by storing the initial value and aggregating it) */

  if (evt.type !== 'scrollend') aggregationKey += '-' + selectorPath;
  return aggregationKey;
}